import api from './api';

/**
 * Needs you — the person's side of the night bookkeeper (17 Oct 2026).
 * The browser names a card and an answer; the server owns every action and number.
 */
const needsYouService = {
  async list() {
    const res = await api.get('/needs-you');
    return res.data?.data || { cards: [], count: 0 };
  },
  async summary() {
    const res = await api.get('/needs-you/summary');
    return res.data?.data || { count: 0, overnight: { fixed: 0, ids: [] } };
  },
  async answer(cardId, answerId, value = null) {
    const res = await api.post(`/needs-you/${encodeURIComponent(cardId)}/answer`, { answerId, value });
    return res.data?.data;
  },
  /** The browser ran the offer; `settle` is the block the offer came with. */
  async answered(cardId, { message, undo, settle }) {
    const res = await api.post(`/needs-you/${encodeURIComponent(cardId)}/answered`, { message, undo, settle });
    return res.data?.data;
  }
};

/** The menu count and the dashboard line re-read after an answer. */
export const NEEDS_YOU_CHANGED = 'kodahfy:needs-you-changed';
export const announceNeedsYouChanged = () => { try { window.dispatchEvent(new Event(NEEDS_YOU_CHANGED)); } catch (_) { /* */ } };

export default needsYouService;
